import React, { useEffect, useState } from 'react'
import { Breadcrumbs, DynamicEntityIndex, EmptyGrid, GlobalLoader, XYChart } from '@reactiveonline/reactive_admin_shared-packages'
import GlobalImports from '../shared/GlobalImports'
import moment from 'moment'
import { truncateString } from '@reactiveonline/reactive_admin_shared-packages/utils'
import SlicedChart from '../shared/SlicedChart'
import PresetDateRangePicker from '../shared/PresetDateRangePicker'

const invoiceTableHeadings = [
  { key: 'month', label: 'month' },
  { key: 'invoices_count', label: 'invoices_count' },
]

export default function TenantShow({
  appProps, breadcrumbs, chartColors, exportMonthlyInvoicesCountPath, fetchTenantInfoPath, icon, startDate, endDate
}) {
  const [loading, setLoading] = useState(false)
  const [salesByPaymentMethodData, setSalesByPaymentMethodData] = useState([])
  const [salesByTidData, setSalesByTidData] = useState([])
  const [salesByChannelData, setSalesByChannelData] = useState([])
  const [salesByStoreData, setSalesByStoreData] = useState(null)
  const [salesByStatusData, setSalesByStatusData] = useState([])
  const [taxDocumentCountPerMonthData, setTaxDocumentCountPerMonthData] = useState([])
  // const [topTenEntities, setTopTenEntities] = useState([])

  const [dateRange, setDateRange] = useState({
    start_date: startDate ? moment(new Date(parseInt(startDate))) : moment().subtract(30, 'days'),
    end_date: endDate ? moment(new Date(parseInt(endDate))) : moment(new Date())
  })

  useEffect(() => {
    fetchData()
  }, [])

  function prepareDataForBarChart(data, xAxis, yAxis){
    let xValues = []
    const finalData = data.map(item => {
      let xValue = truncateString(item[xAxis], 20)
      while (xValues.includes(xValue)){
        xValue = xValue + " "
      }
      xValues.push(xValue)
      return({
        category: xValue,
        [yAxis]: item[yAxis]
      })
    })
    return finalData
  }

  function fetchData(range = dateRange) {
    setLoading(true)

    Rails.ajax({
      type: 'GET',
      url: `${ fetchTenantInfoPath }${ '?date_range=' + JSON.stringify(range) }`,
      dataType: 'json',
      success: res => {
        setSalesByPaymentMethodData(prepareDataForBarChart(res.salesByPaymentMethodData, "method_name", "revenue"))
        setSalesByTidData(prepareDataForBarChart(res.salesByTidData, "terminal_id", "revenue"))
        setSalesByChannelData(prepareDataForBarChart(res.salesByChannelData, "channel", "revenue"))
        // setTopTenEntities(prepareDataForBarChart(res.topTenEntities, "entity_name", "revenue"))
        if (res.salesByStoreData) {
          setSalesByStoreData(prepareDataForBarChart(res.salesByStoreData, "store_name", "revenue"))
        } else {
          setSalesByStoreData(null)
        }

        setSalesByStatusData(res.salesByStatusData.map(item => (
          {
            category: truncateString(item.status, 20),
            revenue: item.revenue
          }
        )))

        setTaxDocumentCountPerMonthData(res.taxDocumentCountPerMonthData)

        setLoading(false)
      }
    })
  }

  function handleApplyDateRange(updatedDateRange) {
    setDateRange(updatedDateRange)
    fetchData(updatedDateRange)
  }

  const itemRenderer = (item, column) => {
    return (
      <div key={ column.label } className='item flex-1'>
        { item[column.key] }
      </div>
    )
  }

  return (
    <>
      <div className='page-wrapper-header flex-box content-space-between'>
        <div className='page-header'>
          <i className={ `fa-light ${ icon }` } />
          <h1 className='page-header-title'>
            { `${ ReactiveCore.translations.reports.sales_by_tenant }(${ breadcrumbs[breadcrumbs.length - 1].title })` }
          </h1>
        </div>

        <div className='flex-box items-center'>
          <PresetDateRangePicker
            value={ dateRange }
            onApply={ handleApplyDateRange }
            maxDateRangeDays={ 366 }
            defaultPresetDays={ 30 }
            allowFutureDates
          />
        </div>
      </div>

      <Breadcrumbs
        breadcrumbs={ breadcrumbs }
      />

      <div className='flex-box flex-wrap items-stretch dashboard-wrapper'>
        <div className='dashboard-item-wrapper'>
          <div className='card' style={{ height: '100%' }}>
            <div className='card-content' style={{ height: '100%' }}>
              <div className="card-title">
                <div className='flex-box items-center'>
                  { Support.translations.reports.sales_by_payment_method }
                </div>
              </div>
              <div className='card-body' style={{ height: '100%' }}>
                { salesByPaymentMethodData.length > 0 ?
                  <XYChart
                    data={ salesByPaymentMethodData }
                    seriesLabels={ [{ revenue: ReactiveCore.translations.columns.gross_sales }] }
                    xAxisTitle={ '' }
                    yAxisTitle={ '' }
                    columnWidth={ 15 }
                    chartColors={ chartColors }
                    chartKey={ "chartdiv1" }
                  />
                  :
                  <div
                    className='flex-box items-center content-center'
                    style={{ height: '100%' }}
                  >
                    <EmptyGrid
                      noResourcesTitle={ ReactiveCore.translations.analytics.noData }
                      iconName={ 'fa-chart-scatter-bubble' }
                      disableReload
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div className='dashboard-item-wrapper'>
          <div className='card' style={{ height: '100%' }}>
            <div className='card-content' style={{ height: '100%' }}>
              <div className="card-title">
                <div className='flex-box items-center'>
                  { ReactiveCore.translations.reports.sales_by_tid }
                </div>
              </div>
              <div className='card-body' style={{ height: '100%' }}>
                { salesByTidData.length > 0 ?
                  <XYChart
                    data={ salesByTidData }
                    seriesLabels={ [{ revenue: ReactiveCore.translations.columns.gross_sales }] }
                    xAxisTitle={ '' }
                    yAxisTitle={ '' }
                    columnWidth={ 15 }
                    chartColors={ chartColors }
                    chartKey={ "chartdiv2" }
                  />
                  :
                  <div
                    className='flex-box items-center content-center'
                    style={{ height: '100%' }}
                  >
                    <EmptyGrid
                      noResourcesTitle={ ReactiveCore.translations.analytics.noData }
                      iconName={ 'fa-chart-scatter-bubble' }
                      disableReload
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div className='dashboard-item-wrapper'>
          <div className='card' style={{ height: '100%' }}>
            <div className='card-content' style={{ height: '100%' }}>
              <div className="card-title">
                <div className='flex-box items-center'>
                  { Support.translations.reports.sales_by_channel }
                </div>
              </div>
              <div className='card-body' style={{ height: '100%' }}>
                { salesByChannelData.length > 0 ?
                  <XYChart
                    data={ salesByChannelData }
                    seriesLabels={ [{ revenue: ReactiveCore.translations.columns.gross_sales }] }
                    xAxisTitle={ '' }
                    yAxisTitle={ '' }
                    columnWidth={ 15 }
                    chartColors={ chartColors }
                    chartKey={ "chartdiv3" }
                  />
                  :
                  <div
                    className='flex-box items-center content-center'
                    style={{ height: '100%' }}
                  >
                    <EmptyGrid
                      noResourcesTitle={ ReactiveCore.translations.analytics.noData }
                      iconName={ 'fa-chart-scatter-bubble' }
                      disableReload
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        {/* Might be fully implemented at a later date */}
        {/* <div className='dashboard-item-wrapper'>
          <div className='card' style={{ height: '100%' }}>
            <div className='card-content'>
              <div className="card-title">
                <div className='flex-box items-center'>
                  { Support.translations.reports.top_entities }
                </div>
              </div>
              <div className='card-body'>
                { topTenEntities.length > 0 ?
                  <XYChart
                    data={ topTenEntities }
                    seriesLabels={ [{ revenue: ReactiveCore.translations.columns.gross_sales }] }
                    xAxisTitle={ '' }
                    yAxisTitle={ '' }
                    columnWidth={ 15 }
                    chartColors={ chartColors }
                    chartKey={ "chartdiv4" }
                  />
                  :
                  <NoData />
                }
              </div>
            </div>
          </div>
        </div> */}

        <div className='dashboard-item-wrapper' style={{ flexBasis: '66%' }}>
          <div className='card' style={{ height: '100%' }}>
            <div className='card-content' style={{ height: '100%' }}>
              <div className="card-title">
                <div className='flex-box items-center'>
                  { ReactiveCore.translations.reports.sales_by_status }
                </div>
              </div>
              <div className='card-body' style={{ height: '100%' }}>
                { salesByStatusData.length > 0 ?
                  <SlicedChart
                    data={ salesByStatusData }
                    chartColors={ chartColors }
                    seriesLabels={ [{ revenue: ReactiveCore.translations.columns.gross_sales }] }
                    chartKey={ "chartdiv5" }
                  />
                  :
                  <div
                    className='flex-box items-center content-center'
                    style={{ height: '100%' }}
                  >
                    <EmptyGrid
                      noResourcesTitle={ ReactiveCore.translations.analytics.noData }
                      iconName={ 'fa-chart-scatter-bubble' }
                      disableReload
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        { salesByStoreData &&
          <div className='dashboard-item-wrapper' style={{ marginRight: 0 }}>
            <div className='card' style={{ height: '100%' }}>
              <div className='card-content' style={{ height: '100%' }}>
                <div className="card-title">
                  <div className='flex-box items-center'>
                    { ReactiveCore.translations.reports.sales_by_store_location }
                  </div>
                </div>
                <div className='card-body' style={{ height: '100%' }}>
                  { salesByStoreData.length > 0 ?
                    <XYChart
                      data={ salesByStoreData }
                      seriesLabels={ [{ revenue: ReactiveCore.translations.columns.gross_sales }] }
                      xAxisTitle={ '' }
                      yAxisTitle={ '' }
                      columnWidth={ 15 }
                      chartColors={ chartColors }
                      chartKey={ "chartdiv6" }
                    />
                    :
                    <div
                      className='flex-box items-center content-center'
                      style={{ height: '100%' }}
                    >
                      <EmptyGrid
                        noResourcesTitle={ ReactiveCore.translations.analytics.noData }
                        iconName={ 'fa-chart-scatter-bubble' }
                        disableReload
                      />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <DynamicEntityIndex
        initialItems={ taxDocumentCountPerMonthData }
        initialTotalPages={ 1 }
        tabs={ [] }
        tableHeadings={ invoiceTableHeadings }
        itemRenderer={ (item, columns) => columns.map(column => itemRenderer(item, column)) }
        icon={ 'fa-file-invoice' }
        noResourcesTitle={ Support.translations.account.no_invoices }
        disableDelete
        disableSearch
        disableCustomization
        disableReload
        forceUpdateItems
        disableUrlUpdates
        isExportable
        exportPath={ exportMonthlyInvoicesCountPath }
        selectAll
      />

      { loading && <GlobalLoader fullPage /> }
      <GlobalImports appProps={ appProps } />
    </>
  )
}
